import Api from '@/api/Api';

class CandidateApplicationsApi extends Api {
  constructor() {
    super('candidates/applications', 'Candidate Applications');
  }
}
const candidateApplicationsApi = new CandidateApplicationsApi();
export default candidateApplicationsApi;
